export const getFlightLogoUrl = (logo: string) => {
    if (!logo || false) {
        return '//ui.cltp.co/images/logos/air-logos/DEFAULT_2x.png'
    }
    logo = logo.replace('3L', 'G9')
    return `//ui.cltp.co/images/logos/air-logos/svg_logos/${logo}.svg`
}
